import Card from "Common/Components/Card/Card";
import logo_demo1 from "../../assets/images/logo-demo1.png"
import React from "react";
import { WithTranslationProps } from "Common/Components/Translation/WithTranslationProps";
import withTranslation from "Common/withTranslation";

const Demos: React.FC<WithTranslationProps> = ({
    t
}) => {
    return(
        <div>
            <section className="relative">
                <div className="text-center py-5">
                    <h1 className="mb-6 leading-normal"><span className="relative inline-block px-2 mx-2 before:block before:absolute before:-inset-1 before:-skew-y-6 before:bg-sky-50 dark:before:bg-sky-500/20 before:rounded-md before:backdrop-blur-xl"><span className="relative text-custom-500">{t("Demos.Title")}</span></span></h1>
                </div>
            </section>
            <section className="relative">
                <div className="grid grid-cols-1 gap-6 md:grid-cols-3 xl:grid-cols-12 ">
                    <div className="col-span-1 xl:col-span-4">
                        <Card img={logo_demo1} width={250} link="https://demos.demo1.soi-soluciones.com/" text_alignment="text-center" title={t("Demos.Demo1Title")} paragraph={t("Demos.Demo1Description")} paragraph_text_size="text-6" externalLink={true}></Card>
                    </div>                    
                </div>
            </section>
        </div>
    )
}

export default withTranslation(Demos);